import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from "vue-router"
import tools from '@/tools'

import { useUserStore } from '@/store/user'
import request from '@/plugin/request'
import work from '@/plugin/work'

import { Toast } from 'vant';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const user = useUserStore()


const router = useRouter();

onMounted(async () => {

  const params = tools.data.getUrlParams()

  request('/work/login', { code: params.code }, { method: 'POST', loading: true }).then(res => {
    console.log(res)

    work.get_agent()

    work.wecom.invoke('getContext', {}, (res: any) => {
      if (res.errMsg === 'getContext:ok') {
        console.log(res.entry)
      }
    });
  })
  console.log(params.code)


})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, "Index3333"))
}
}

})